﻿import * as $ from 'jquery';
import { IEventAggregator, disposableSubscription } from 'common/barrels/core';
import { IResourceProvider } from 'common/resourceprovider';
import { IActivityButtonOptions, IAutoCompleteListOptions, ICheckBoxOptions, IDropDownListOptions, IDateTimePickerOptions, INumericBoxOptions, ITextBoxOptions } from 'runtime/extensions/jqueryextensions';
import { LookupItem } from 'runtime/data/lookupitem';
import { Control } from 'runtime/controls/control';
import { LookupItemRequested } from 'runtime/events/lookupitemrequested';
import { LookupItemsRequested } from 'runtime/events/lookupitemsrequested';
import { FilteredLookupItemsRequested } from 'runtime/events/filteredlookupitemsrequested';
import * as ko from 'knockout';
import { Observable as KnockoutObservable, BindingContext as KnockoutBindingContext, AllBindings as KnockoutAllBindingsAccessor } from 'knockout';

interface IActivityButtonValueAccessor {
    click: () => void;
    //clickBubble?: boolean;
    text: string|KnockoutObservable<string>;
    options?: IActivityButtonOptions;
}

interface IAutoCompleteListValueAccessor {
    selectedValue: KnockoutObservable<string>;
    context: string;
    filteredLookupItems: (filter: string) => LookupItem[];
    options?: IAutoCompleteListOptions;
}

interface ICheckBoxValueAccessor {
    isChecked: KnockoutObservable<boolean>;
    options?: ICheckBoxOptions;
}

interface IDateTimePickerValueAccessor {
    selectedDate: KnockoutObservable<string>;
    options?: IDateTimePickerOptions;
}

interface IDropDownListValueAccessor {
    selectedValue: KnockoutObservable<string>;
    context: string;
    lookupItems: () => LookupItem[];
    lookupItem: (keyValue: any) => LookupItem;
    options?: IDropDownListOptions;
}

interface INumericBoxValueAccessor {
    value: KnockoutObservable<number>;
    options?: INumericBoxOptions;
}

interface ITextBoxValueAccessor {
    value: KnockoutObservable<string>;
    options?: ITextBoxOptions;
}

interface IViewModelRoot {
    eventAggregator: IEventAggregator;
    resources: IResourceProvider;
}

interface IKnockoutBindingContext extends KnockoutBindingContext {
    $root: IViewModelRoot;
}

// ReSharper disable once Lambda
(function (ko) {
    var handleEnabled = (control: Control, allBindings: KnockoutAllBindingsAccessor): void => {
        if (allBindings.has('enabled')) {
            var enabledBinding = allBindings.get('enabled');
            var enabled = ko.unwrap(enabledBinding);
            control.isElementEnabled(enabled);
        }
        if (allBindings.has('disabled')) {
            var disabledBinding = allBindings.get('disabled');
            var disabled = ko.unwrap(disabledBinding);
            control.isElementEnabled(!disabled);
        }
    };
    var handleVisible = (control: Control, allBindings: KnockoutAllBindingsAccessor): void => {
        //if (allBindings.has('visible')) {
        //    var visibleBinding = allBindings.get('visible');
        //    var visible = ko.unwrap(visibleBinding);
        //    control.isElementVisible(visible);
        //}
    };

    ko.bindingHandlers['activityButton'] = {
        init: (element: HTMLElement, valueAccessor: () => IActivityButtonValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            //var options: IActivityButtonOptions = {
            //    contentText: ko.unwrap(value.text)
            //};
            var options: IActivityButtonOptions = ko.unwrap(value.options) || <any>{};
            options.contentText = ko.unwrap(value.text);

            var activityButton = $(element).activityButton(bindingContext.$root.eventAggregator, bindingContext.$root.resources, options).controlInstance();

            // Subscribe to value changes
            $(element).on('events.Clicked', (/*eventObject: JQueryEventObject, args: any*/) => value.click.call(bindingContext.$data));

            handleEnabled(activityButton, allBindings);
            handleVisible(activityButton, allBindings);
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => IActivityButtonValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            //// First get the latest data that we're bound to
            //var value = valueAccessor();
            //// Next, whether or not the supplied model property is observable, get its current value
            //var valueUnwrapped = ko.unwrap(value);

            var activityButton = Control.instance(element);

            //// Set the updated value
            //activityButton['events.Clicked'](valueUnwrapped);

            handleEnabled(activityButton, allBindings);
            handleVisible(activityButton, allBindings);
        }
    };

    ko.bindingHandlers['autoCompleteList'] = {
        init: (element: HTMLElement, valueAccessor: () => IAutoCompleteListValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var fieldContext = ko.unwrap(value.context);

            //var options: IAutoCompleteListOptions = allBindings.has('options') ? allBindings.get('options') : null;
            var options: IAutoCompleteListOptions = ko.unwrap(value.options);

            var autoCompleteList = $(element).autoCompleteList(bindingContext.$root.eventAggregator, bindingContext.$root.resources, fieldContext, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.SelectedValue', (eventObject: JQueryEventObject, args: string) => value.selectedValue.call(bindingContext.$data, args));

            handleEnabled(autoCompleteList, allBindings);
            handleVisible(autoCompleteList, allBindings);

            // Subscribe to list items requests
            var disposable = disposableSubscription(
                bindingContext.$root.eventAggregator.queryRequest(FilteredLookupItemsRequested).subscribe(x => {
                    var items = value.filteredLookupItems.call(bindingContext.$data, x.payload.filter);
                    x.success(items);
                })
            );

            

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                // This will be called when the element is removed by Knockout or
                // if some other part of your code calls ko.removeNode(element)
                disposable.dispose();
            });
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => IAutoCompleteListValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();
            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: string = <any>ko.unwrap(value);

            var autoCompleteList = $(element).controlInstance();

            // Set the updated value
            autoCompleteList['content.SelectedValue'](valueUnwrapped);

            handleEnabled(autoCompleteList, allBindings);
            handleVisible(autoCompleteList, allBindings);
        }
    };

    ko.bindingHandlers['checkBox'] = {
        init: (element: HTMLElement, valueAccessor: () => ICheckBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var options: ICheckBoxOptions = ko.unwrap(value.options);

            var checkBox = $(element).checkBox(bindingContext.$root.eventAggregator, bindingContext.$root.resources, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.IsChecked', (eventObject: JQueryEventObject, args: boolean) => value.isChecked.call(bindingContext.$data, args));

            handleEnabled(checkBox, allBindings);
            handleVisible(checkBox, allBindings);
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => ICheckBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();
            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: boolean = ko.unwrap(value.isChecked);

            var checkBox = $(element).controlInstance();

            // Set the updated value
            checkBox['content.IsChecked'](valueUnwrapped);

            handleEnabled(checkBox, allBindings);
            handleVisible(checkBox, allBindings);
        }
    };

    ko.bindingHandlers['dateTimePicker'] = {
        init: (element: HTMLElement, valueAccessor: () => IDateTimePickerValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var options: IDateTimePickerOptions = ko.unwrap(value.options);

            var dateTimePicker = $(element).dateTimePicker(bindingContext.$root.eventAggregator, bindingContext.$root.resources, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.SelectedDate', (eventObject: JQueryEventObject, args: string) => value.selectedDate.call(bindingContext.$data, args));

            handleEnabled(dateTimePicker, allBindings);
            handleVisible(dateTimePicker, allBindings);
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => IDateTimePickerValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();
            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: string = ko.unwrap(value.selectedDate);

            var dateTimePicker = $(element).controlInstance();

            // Set the updated value
            dateTimePicker['content.SelectedDate'](valueUnwrapped);

            handleEnabled(dateTimePicker, allBindings);
            handleVisible(dateTimePicker, allBindings);
        }
    };

    ko.bindingHandlers['dropDownList'] = {
        init: (element: HTMLElement, valueAccessor: () => IDropDownListValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var fieldContext = ko.unwrap(value.context);

            var options = ko.unwrap(value.options);

            var dropDownList = $(element).dropDownList(bindingContext.$root.eventAggregator, bindingContext.$root.resources, fieldContext, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.SelectedValue', (eventObject: JQueryEventObject, args: string) => value.selectedValue.call(bindingContext.$data, args));

            handleEnabled(dropDownList, allBindings);
            handleVisible(dropDownList, allBindings);

            // Subscribe to list items requests
            var disposable = disposableSubscription(
                bindingContext.$root.eventAggregator.queryRequest(LookupItemsRequested).subscribe(x => {
                    if (x.payload.fieldContext !== undefined && x.payload.fieldContext !== null && x.payload.fieldContext === fieldContext) {
                        var items = value.lookupItems.call(bindingContext.$data);
                        x.success(items);
                    }
                }),

                bindingContext.$root.eventAggregator.queryRequest(LookupItemRequested).subscribe(x => {
                    if (x.payload.fieldContext !== undefined && x.payload.fieldContext !== null && x.payload.fieldContext === fieldContext) {
                        var item = value.lookupItem.call(bindingContext.$data, x.payload.keyValue);
                        x.success(item);
                    }
                })
            );
            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                // This will be called when the element is removed by Knockout or
                // if some other part of your code calls ko.removeNode(element)
                disposable.dispose();
            });
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => IDropDownListValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: string = ko.unwrap(value.selectedValue);

            var dropDownList = $(element).controlInstance();

            // Set the updated value
            dropDownList['content.SelectedValue'](valueUnwrapped);

            handleEnabled(dropDownList, allBindings);
            handleVisible(dropDownList, allBindings);
        }
    };

    ko.bindingHandlers['numericBox'] = {
        init: (element: HTMLElement, valueAccessor: () => INumericBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var options: INumericBoxOptions = ko.unwrap(value.options);

            var numericBox = $(element).numericBox(bindingContext.$root.eventAggregator, bindingContext.$root.resources, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.Value', (eventObject: JQueryEventObject, args: number) => value.value.call(bindingContext.$data, args));

            handleEnabled(numericBox, allBindings);
            handleVisible(numericBox, allBindings);
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => INumericBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();
            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: number = ko.unwrap(value.value);

            var numericBox = $(element).controlInstance();

            // Set the updated value
            numericBox['content.Value'](valueUnwrapped);

            handleEnabled(numericBox, allBindings);
            handleVisible(numericBox, allBindings);
        }
    };

    ko.bindingHandlers['textBox'] = {
        init: (element: HTMLElement, valueAccessor: () => ITextBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();

            var options = $.extend(ko.unwrap(value.options) || {}, { contentUpdateBindingOnTextChanged: true, contentText: 'initial' });

            var textBox = $(element).textBox(bindingContext.$root.eventAggregator, bindingContext.$root.resources, options).controlInstance();

            // Subscribe to value changes
            $(element).on('content.Text', (eventObject: JQueryEventObject, args: string) => value.value.call(bindingContext.$data, args));

            handleEnabled(textBox, allBindings);
            handleVisible(textBox, allBindings);
        },
        // ReSharper disable once UnusedParameter
        update: (element: HTMLElement, valueAccessor: () => ITextBoxValueAccessor, allBindings: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: IKnockoutBindingContext) => {
            // First get the latest data that we're bound to
            var value = valueAccessor();
            // Next, whether or not the supplied model property is observable, get its current value
            var valueUnwrapped: string = ko.unwrap(value.value);

            var textBox = $(element).controlInstance();

            // Set the updated value
            textBox['content.Text'](valueUnwrapped);

            handleEnabled(textBox, allBindings);
            handleVisible(textBox, allBindings);
        }
    };
} (ko));